// @ts-ignore
import content from './md/marketing-lists-guide.md';

export const meta = {
  slug: 'marketing-lists-guide',
  title: 'Marketing Dashboard Guide',
  excerpt: 'A comprehensive guide to the Marketing Dashboard, including tools for managing leads, customer lists, email/SMS templates, and campaigns.',
  date: 'January 2025',
  readTime: '12 min read',
  image: '/docs/marketing-lists-guide/header.png'
};

export { content };
